export default "__VITE_PUBLIC_ASSET__ff87d200__"